import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=73962a2c&scoped=true&"
import script from "./cookie-banner.vue?vue&type=script&lang=ts&"
export * from "./cookie-banner.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-banner.vue?vue&type=style&index=0&id=73962a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73962a2c",
  null
  
)

export default component.exports